import React, { useEffect, useState } from 'react'
import {
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
} from '@mui/material'
import CancelIcon from '@mui/icons-material/Cancel'
import { useLang } from '~/hooks/useLang'

interface FielderTExtFieldProps {
  readonly onTextFieldChange: (value: string | null) => void
  readonly currentText: string | null
  readonly label: string
  readonly error?: boolean
  readonly isRequired?: boolean
  readonly disabled?: boolean
  readonly hideEndAdornment?: boolean
  readonly type?: string
}

export default function FilterTextField({
  currentText,
  label,
  onTextFieldChange,
  error,
  isRequired = false,
  disabled = false,
  hideEndAdornment = false,
  type = 'text'
}: FielderTExtFieldProps) {
  const { translate } = useLang()
  const [value, setValue] = useState<string | null>(null)

  useEffect(() => {
    if (!currentText) {
      setValue('')
    } else {
      setValue(currentText)
    }
  }, [currentText])

  return (
    <FormControl variant="standard" fullWidth>
      <OutlinedInput
        id={label}
        value={value}
        size="small"
        type={type}
        placeholder={`${translate(label)}${isRequired ? ' *' : ''}`} 
        onChange={(event) => {
          setValue(event.target.value)
        }}
        onBlur={() => onTextFieldChange(value)}
        error={error ? error : false}
        disabled={disabled}
        sx={{
          '& .MuiOutlinedInput-input::placeholder': {
            color: error ? '#d32f2f' : 'inherit',
            opacity: 0.7,
          },
        }}
        endAdornment={
          !hideEndAdornment ? (
          <InputAdornment position="end">
            <IconButton
              aria-label="toggle clear filterText"
              onClick={() => {
                setValue('')
                onTextFieldChange(null)
              }}
              edge="end"
            >
              {value?.length ? <CancelIcon fontSize="small" /> : ''}
            </IconButton>
            </InputAdornment>)
            : <></>
        }
      />
    </FormControl>
  )
}
